// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"195441c6","380":"e55bdd5f","428":"59a1efd4","452":"195441c6","453":"b39d569a","521":"7e98776a","685":"7c71545e","866":"01471f35","902":"05e936cd"}[chunkId] + ".chunk.js";
};